{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Κατέβασμα",
      "UPLOADING": "Ανέβασμα..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Καταχώρηση"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Επαναποστολή μηνύματος",
      "ERROR_MESSAGE": "Αδυναμία αποστολής! Προσπαθήστε ξανά"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Not available"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Είμαστε online",
    "OFFLINE": "Προς το παρόν, είμαστε εκτός",
    "BACK_AS_SOON_AS_POSSIBLE": "We will be back as soon as possible"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Τυπικά έχετε απάντηση σε μερικά λεπτά",
    "IN_A_FEW_HOURS": "Τυπικά έχετε απάντηση σε μερικές σε μερικές ώρες",
    "IN_A_DAY": "Τυπικά έχετε απάντηση σε μία ημέρα",
    "BACK_IN_HOURS": "We will be back online in {n} hour | We will be back online in {n} hours",
    "BACK_IN_MINUTES": "We will be back online in {time} minutes",
    "BACK_AT_TIME": "We will be back online at {time}",
    "BACK_ON_DAY": "We will be back online on {day}",
    "BACK_TOMORROW": "We will be back online tomorrow",
    "BACK_IN_SOME_TIME": "We will be back online in some time"
  },
  "DAY_NAMES": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "START_CONVERSATION": "Έναρξη Συνομιλίας",
  "END_CONVERSATION": "Τέλος Συνομιλίας",
  "CONTINUE_CONVERSATION": "Συνέχιση συνομιλίας",
  "YOU": "You",
  "START_NEW_CONVERSATION": "Έναρξη νέας συνομιλίας",
  "VIEW_UNREAD_MESSAGES": "You have unread messages",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Δείτε τα νέα μηνύματα",
    "CLOSE_MESSAGES_BUTTON": "Κλείσιμο",
    "COMPANY_FROM": "από",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Συνομιλήστε μαζί μας"
  },
  "POWERED_BY": "με την δύναμη του Chatwoot",
  "EMAIL_PLACEHOLDER": "Παρακαλώ εισάγετε το email σας",
  "CHAT_PLACEHOLDER": "Πληκτρολογήστε το μήνυμά σας",
  "TODAY": "Σήμερα",
  "YESTERDAY": "Χτες",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Πλήρες Όνομα",
        "PLACEHOLDER": "Παρακαλώ συμπληρώστε το πλήρες όνομα σας",
        "REQUIRED_ERROR": "Απαιτείται πλήρες όνομα"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Διεύθυνση Email",
        "PLACEHOLDER": "Παρακαλούμε εισάγετε τη διεύθυνση email σας",
        "REQUIRED_ERROR": "Απαιτείται διεύθυνση email",
        "VALID_ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email"
      },
      "PHONE_NUMBER": {
        "LABEL": "Αριθμός Τηλεφώνου",
        "PLACEHOLDER": "Παρακαλώ εισάγετε τον αριθμό του τηλεφώνου σας",
        "REQUIRED_ERROR": "Απαιτείται ο αριθμός τηλεφώνου",
        "DIAL_CODE_VALID_ERROR": "Please select a country code",
        "VALID_ERROR": "Please enter a valid phone number",
        "DROPDOWN_EMPTY": "Δεν βρέθηκαν αποτελέσματα",
        "DROPDOWN_SEARCH": "Search country"
      },
      "MESSAGE": {
        "LABEL": "Μήνυμα",
        "PLACEHOLDER": "Παρακαλώ εισάγετε το μήνυμά σας",
        "ERROR": "Πολύ σύντομο μήνυμα"
      }
    },
    "CAMPAIGN_HEADER": "Παρακαλώ δώστε το όνομα και το email σας πριν ξεκινήσετε την συνομιλία",
    "IS_REQUIRED": "είναι απαραίτητο",
    "REQUIRED": "Υποχρεωτικό",
    "REGEX_ERROR": "Please provide a valid input"
  },
  "FILE_SIZE_LIMIT": "Το αρχείο υπερβαίνει το όριο συνημμένου {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Μη έγκυρο πεδίο"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Αναζήτηση emojis",
    "NOT_FOUND": "Κανένα emoji δεν ταιριάζει με την αναζήτησή σας",
    "ARIA_LABEL": "Emoji picker"
  },
  "EMOJI_ICON_PICKER": {
    "SEARCH_EMOJI": "Search emoji…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Κανένα emoji δεν ταιριάζει με την αναζήτησή σας"
  },
  "CSAT": {
    "TITLE": "Αξιολογήστε τη συνομιλία σας",
    "SUBMITTED_TITLE": "Ευχαριστούμε για την υποβολή της αξιολόγησης",
    "PLACEHOLDER": "Πείτε μας περισσότερα..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Αίτηση μεταγραφής συνομιλίας",
    "SEND_EMAIL_SUCCESS": "Η μεταγραφή της συνομιλίας έχει αποσταλεί επιτυχώς",
    "SEND_EMAIL_ERROR": "Υπήρξε ένα σφάλμα, παρακαλώ προσπαθήστε ξανά"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Κάντε κλικ εδώ για να συμμετάσχετε",
      "LEAVE_THE_ROOM": "Έξοδος από την κλήση"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popular Articles",
    "VIEW_ALL_ARTICLES": "View all articles",
    "IFRAME_LOAD_ERROR": "There was an error loading the article, please refresh the page and try again."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Μήνυμα εικόνας"
    },
    "audio": {
      "CONTENT": "Μήνυμα ήχου"
    },
    "video": {
      "CONTENT": "Μήνυμα βίντεο"
    },
    "file": {
      "CONTENT": "Επισυναπτόμενο αρχείο"
    },
    "location": {
      "CONTENT": "Θέση"
    },
    "fallback": {
      "CONTENT": "έχει μοιράσει ένα σύνδεσμο"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Replying to:"
  }
}
